import _jsx from "@babel/runtime/helpers/jsx";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React from 'react';
import { defineMessages } from 'react-intl';
import _ from 'lodash';
import Layout from '../../components/Layout';
import Cert from './Cert';
import notFound from '../not-found/index';
import { getCert, reset } from '../../actions/cert';
import { isSupportAdminAuth, isWhitelabeledOrganizationAdmin, ssrRequest } from '../../helpers';
import { getUser } from '../../actions/editUser';
var messages = defineMessages({
  title: {
    id: "Cert.title",
    defaultMessage: [{
      "type": 1,
      "value": "name"
    }, {
      "type": 0,
      "value": " - Certificate"
    }]
  }
});
function action(_x) {
  return _action.apply(this, arguments);
}
function _action() {
  _action = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(context) {
    var store, fetch, params, intl, code, res, notFoundReq, _store$getState, cert, auth, isBundleCert, title, isCertPublic, filePath, imageUrl, cloudfrontUrl;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          store = context.store, fetch = context.fetch, params = context.params, intl = context.intl;
          code = params.code;
          _context.next = 4;
          return ssrRequest({
            store: store,
            fetch: fetch,
            getAction: getCert.bind(this, code),
            resetAction: reset,
            context: context
          });
        case 4:
          res = _context.sent;
          notFoundReq = _.get(res, 'status') >= 400;
          if (!notFoundReq) {
            _context.next = 8;
            break;
          }
          return _context.abrupt("return", notFound(context));
        case 8:
          _store$getState = store.getState(), cert = _store$getState.cert, auth = _store$getState.auth;
          isBundleCert = !!_.get(cert, 'cert.certificateCollectionId');
          if (!isBundleCert) {
            _context.next = 13;
            break;
          }
          _context.next = 13;
          return ssrRequest({
            getAction: getUser.bind(this, _.get(cert, 'cert.userId'), isSupportAdminAuth(auth) || isWhitelabeledOrganizationAdmin(auth)),
            store: store,
            fetch: fetch,
            context: context
          });
        case 13:
          title = intl.formatMessage(messages.title, {
            name: _.get(cert, 'cert.name', '')
          });
          isCertPublic = _.get(cert, 'cert.isPublic', false);
          filePath = _.get(cert, 'cert.file.path', '');
          imageUrl = null;
          if (!isBundleCert && isCertPublic && filePath) {
            cloudfrontUrl = _.get(context, 'cloudfrontUrl');
            imageUrl = "".concat(cloudfrontUrl, "/").concat(filePath);
          }
          return _context.abrupt("return", {
            chunks: ['cert'],
            title: title,
            imageUrl: imageUrl,
            component: /*#__PURE__*/_jsx(Layout, {
              context: context
            }, void 0, /*#__PURE__*/_jsx(Cert, {
              data: {},
              title: title
            }))
          });
        case 19:
        case "end":
          return _context.stop();
      }
    }, _callee, this);
  }));
  return _action.apply(this, arguments);
}
export default action;